<div class="modal-overlay" *ngIf="previewMode" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Choose {{ title }}</h3>
      <button class="close-btn" (click)="onClose()" title="Close">×</button>
    </div>

    <div class="modal-body">
      <div class="layout-column">
        <div
          *ngFor="let sceneGroup of currentPreviewScenes; let i = index"
          class="layout-row"
        >
          <div
            class="layout-option"
            *ngFor="let scene of sceneGroup"
            [class.selected]="selectedPreviewScene === scene"
            (click)="selectPreviewScene(scene)"
          >
            <div class="layout-preview" [style.width.px]="240">
              <div #previewCanvas class="preview-canvas"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="loading-overlay" *ngIf="isLoading">
        <nw-loader [size]="32"></nw-loader>
      </div> -->
    </div>
    <!-- <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button
        class="btn btn-primary"
        [disabled]="!selectedLayout"
        (click)="applyLayout()"
      >
        Apply Layout
      </button>
    </div> -->
  </div>
</div>
